import { FeatureFlags } from '../contexts/FeatureFlagsContext';
import { tenantService } from './tenantService';

export interface FeatureFlagsResponse {
  flags: FeatureFlags;
  version?: string;
  lastModified?: string;
}

class FeatureFlagsService {
  private baseUrl = import.meta.env.VITE_SIMPLE_REST_URL;

  async getFeatureFlags(): Promise<FeatureFlagsResponse> {
    const token = localStorage.getItem('accessToken');

    // Add tenant code header
    let tenantCode: string;
    try {
      tenantCode = tenantService.getCurrentTenantCode();
    } catch (error) {
      throw new Error('No tenant selected. Please select a tenant to continue.');
    }

    const response = await fetch(`${this.baseUrl}/feature-flags`, {
      method: 'GET',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
        'x-tenant-code': tenantCode,
      },
    });

    if (!response.ok) {
      throw new Error(`Feature flags API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  }

  async updateFeatureFlag(category: string, flagName: string, enabled: boolean): Promise<void> {
    const token = localStorage.getItem('accessToken');

    // Add tenant code header
    let tenantCode: string;
    try {
      tenantCode = tenantService.getCurrentTenantCode();
    } catch (error) {
      throw new Error('No tenant selected. Please select a tenant to continue.');
    }

    const response = await fetch(`${this.baseUrl}/feature-flags/${category}/${flagName}`, {
      method: 'PUT',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
        'x-tenant-code': tenantCode,
      },
      body: JSON.stringify({ enabled }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update feature flag: ${response.status} ${response.statusText}`);
    }
  }

  async updateFeatureFlags(flags: Partial<FeatureFlags>): Promise<void> {
    const token = localStorage.getItem('accessToken');

    // Add tenant code header
    let tenantCode: string;
    try {
      tenantCode = tenantService.getCurrentTenantCode();
    } catch (error) {
      throw new Error('No tenant selected. Please select a tenant to continue.');
    }

    const response = await fetch(`${this.baseUrl}/feature-flags`, {
      method: 'PUT',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
        'x-tenant-code': tenantCode,
      },
      body: JSON.stringify({ flags }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update feature flags: ${response.status} ${response.statusText}`);
    }
  }
}

export const featureFlagsService = new FeatureFlagsService();
